export default function($httpProvider, jwtOptionsProvider){
	jwtOptionsProvider.config({
      	tokenGetter: [function() {
	        return localStorage.getItem('token');
		}],
		whiteListedDomains: ['localhost', '52.88.201.105:8080', /.+\w/g],
		authPrefix: ''
    });

    $httpProvider.interceptors.push('jwtInterceptor');
}



// WEBPACK FOOTER //
// ./app/js/config/jwt.js